import React from "react";
import { PageHeader, BankHesapListTable } from "../components/bankaHesapListe";
import { Space } from "antd";

export default function BankaHesapListe() {
  return (
    <>
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <PageHeader />
        <BankHesapListTable />
      </Space>
    </>
  );
}
